import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import { URLS } from '../../_config';
import Icon from '../../components/icons';
import { AgGridReact } from 'ag-grid-react';
import { data, useNavigate } from 'react-router-dom';
import Drawer from '../../components/Drawer';
import CreateAssets from './_components/createAssets';
import { Dropdown, Menu } from '../../components/Dropdown';
import Button from '../../components/elements/button';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import Search from '../../components/search';
import moment from 'moment';
import StatusChangeReasonModal from './_components/statusChangeReason.modal';
import { statusChangeDataType } from '../../_common/types';
import { useDialog } from '../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { downloadExcel, downloadPDF } from '../../_common/functions';
import Loader from '../../components/loader';
import { filterConfigType } from '../../_config/types';
import Filters from '../../components/filters';
import { useAssestCategoriesSelector, useAssestClassificationsSelector, useAssestDepartmentsSelector, useAssestGroupsSelector, useAssestStatuesSelector, useAssestSubGroupsSelector, useAssestTypesSelector } from '../../store/selectors/masterSelector';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
import { titleCell } from '../../components/elements/function';

const Assets: React.FC = () => {
    const assetsAPI = useAssetsApi();
    const navigate = useNavigate();
    const facilityApi: any = useFacilitiesApi();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);

    const addNewAssetRef: any = React.createRef<HTMLButtonElement>();
    const [statusChangeData, setStatusChangeData] = useState<statusChangeDataType>(null);

    const statusChangeReasonModalRef: any = useRef()

    const [statuslist, setstatusList] = useState<any>(null);
    const [facilityoption, setFacilityoption] = useState<any>([]);

    const { confirm } = useDialog();


    const [columnDefs, setColumnDefs] = useState<any[] | null>(null)

    // Define row data
    const [rowData, setRowData] = useState<any>(null)

    const assetsCategories = useAssestCategoriesSelector();
    const assetsDepartments = useAssestDepartmentsSelector();
    const assetsGroups = useAssestGroupsSelector();
    const assetsSubGroups = useAssestSubGroupsSelector();
    const assetsTypes = useAssestTypesSelector();
    const assetsClassifications = useAssestClassificationsSelector();
    const assetsStatues = useAssestStatuesSelector();

    useEffect(() => {
        if(assetsCategories == null){
            assetsAPI.getAssetCategpry({}, (resp: any) => {}, (error: any) => {});
        }
    },[assetsCategories]);

    useEffect(() => {
        if(assetsDepartments == null){
            assetsAPI.getAssetdepartment({}, (resp: any) => {}, (error: any) => {});
        }
    },[assetsDepartments]);

    useEffect(() => {
        if(assetsGroups == null){
            assetsAPI.getAssetGrouplist({}, (resp: any) => {}, (error: any) => {});
        }
    },[assetsGroups]);

    useEffect(() => {
        if(assetsSubGroups == null){
            assetsAPI.getAssetSubGrouplist({}, (resp: any) => {}, (error: any) => {});
        }
    },[assetsSubGroups]);

    useEffect(() => {
        if(assetsTypes == null){
            assetsAPI.GetAssetTypeList({}, (resp: any) => {}, (error: any) => {});
        }
    },[assetsTypes]);

    useEffect(() => {
        if(assetsClassifications == null){
            assetsAPI.GetAssetClassificationList({}, (resp: any) => {}, (error: any) => {});
        }
    },[assetsClassifications]);

    useEffect(() => {
        if(assetsStatues == null){
            assetsAPI.GetAssetStatusList({}, (resp: any) => {}, (error: any) => {});
        }
    },[assetsStatues]);


    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const filterConfig: filterConfigType[] = [
        { name: 'Name', type: 'text', key: 'assetName' },
        
        { name: 'Asset Category', type: 'dropdown', key: 'assetCategoryIDs', options: assetsCategories ? assetsCategories : [] },
        { name: 'Department', type: 'dropdown',  key: 'departmentIDs' , options: assetsDepartments ? assetsDepartments : [] },
        { name: 'Group', type: 'dropdown',  key: 'accountGroupIDs', options: assetsGroups ? assetsGroups : [] },
        { name: 'Sub Group', type: 'dropdown',  key: 'assetSubGroupIDs', options: assetsSubGroups ? assetsSubGroups : [] },
        { name: 'Type', type: 'dropdown',  key: 'assetTypeIDs', options: assetsTypes ? assetsTypes : [] },
        { name: 'Classification', type: 'dropdown',  key: 'assetClassificationIDs', options: assetsClassifications ? assetsClassifications : [] },
        { name: 'Status', type: 'dropdown',  key: 'statusIDs', options: assetsStatues ? assetsStatues : [] },
    ]

    const getfacilitylist = () => {
		const payload = {};
		facilityApi.getFacilityList(
			payload,
			(resp: any) => {
				let facilitylist: any = [];
				resp.facilityList.map((facility: any) => {
					facilitylist.push({
						label: facility.facilityName,
						value: facility.facilityID,
                        data:facility
					});
				});
				setFacilityoption(facilitylist);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};




    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onBulkMoveAssets = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);

        // Example: Perform deletion action, removing selected rows from the rowData
        // In real implementation, you would remove the selected data from your state or backend
        //gridApi.applyTransaction({ remove: selectedData });
    };

    const onBulkExport = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
    };

    const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const assetIDs = selectedData.map((asset: any) => asset.assetID).join(',');
            const payload = { assetIDs: assetIDs };
            assetsAPI.Exportpdf(
                payload,
                (resp: any) => {
                    downloadPDF(resp, 'assets')
                },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const assetIDs = selectedData.map((asset: any) => asset.assetID).join(',');
            const payload = { assetIDs: assetIDs };
            assetsAPI.Exportcsv(
                payload,
                (resp: any) => { downloadExcel(resp, 'assets') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };

    const onBulkPrintQR = () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            let qrAssetList: any = [];
            selectedData?.map((asset: any) => qrAssetList.push({ assetID: asset.assetID, qty: 1 }));
            const payload = { qrAssetList: qrAssetList, assetNameInQR: true };
            assetsAPI.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'assets') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };

    const GetAssetStatusList = () => {
        const payload = {};
        assetsAPI.GetAssetStatusList(
            payload,
            (resp: any) => {
                let deptlist: any = [];

                resp.assetStatusList.map((facilist: any) => {
                    deptlist.push({
                        label: facilist.statusName,
                        value: facilist.statusID,
                    });
                });
                setstatusList(deptlist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":
                // Implement edit action
                setEditData(rowData);
                addNewAssetRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Asset',
                    message: 'Are you sure you want to delete this asset?',
                    onConfirm: () => {
                        assetsAPI.deleteAsset({ assetID: rowData.assetID }, (data: any, msg:any) => {
                            toast.success(msg);
                            getAssetsList();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;
            case "duplicate":
                console.log("Duplicate action for row: ", rowData);
                break;
            case "move-asset":
                // Implement move asset action
                console.log("Move Asset action for row: ", rowData);
                break;
            case "qr": 
                console.log("QR Code action for row: ", rowData); 
 
                const payload = { qrAssetList: [{ assetID: rowData.assetID, qty: 1 }], assetNameInQR: true };
                assetsAPI.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'AssetsQr') },
                    (error: any) => {
                        console.log("error =>", error);
                        toast.error(error);
                    }
                );
                break;
            case "schedule-maintenance":
                // Implement schedule maintenance action
                console.log("Schedule Maintenance action for row: ", rowData);
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const getAssetsList = () => {
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        assetsAPI.getAssetsList(payload, (data: any) => {
            setRowData(data.assetList ? data.assetList : []);
            setTotalRecords(data.totalRecord);
        }, (error: any) => { });
    };

    useEffect(() => {
        getfacilitylist();
        GetAssetStatusList();
        getAssetsList();
    }, []);

    useEffect(() => {
        if (statuslist?.length > 0) {
            setColumnDefs([
                { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
                { headerName: 'Asset ID', field: 'assetCode', headerClass: 'bg-[#f0f0f0]', width: 160 },
                {
                    headerName: 'Asset Name', field: 'name', headerClass: 'bg-[#f0f0f0]', width: 300,
                    cellRenderer: (data: any) => {
                        return (
                            <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                        )
                    }, onCellClicked: (param: any) => {
                        navigate(URLS.ASSETS_DETAILS(param.data.assetID));
                    }
                },
                { headerName: 'Category', field: 'categoryName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer:titleCell  },
                { headerName: 'Facility Name', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer:titleCell },
                {
                    headerName: 'Status', field: 'statusName', headerClass: 'bg-[#f0f0f0]', width: 200, cellStyle: {
                        alignItems: 'center'
                    }, cellRenderer: (data: any) => {
                        return (
                            <div className='flex items-center gap-2 h-full'>
                                <div className='w-[0.5rem] h-[0.5rem] rounded-full bg-red-700 flex-shrink-0'></div>
                                <select
                                    className="status-dropdown flex-grow"
                                    onChange={(e) => {
                                        setStatusChangeData({
                                            assetID: data.data.assetID,
                                            status: {
                                                id: e.target.value,
                                                label: e.target.options[e.target.selectedIndex].text
                                            }
                                        });
                                        statusChangeReasonModalRef?.current?.showModal()
                                    }}
                                >
                                    {statuslist.map((status: any) => {
                                        return (
                                            <option value={status.value} selected={data.data.statusID == status.value}>{status.label}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        )
                    }
                },

                {
                    headerName: 'Last Maintenance Date', field: 'last-date', headerClass: 'bg-[#f0f0f0]', width: 200,
                    cellRenderer: (data: any) => {
                        return (
                            <p className='hover:text-primary font-semibold cursor-pointer'>{data.value ? moment(data.value).format(DATE_FORMAT) : '-'}</p>
                        )
                    }
                },
                {
                    headerName: 'Warranty Expiry Date', field: 'warrantyEndDate', headerClass: 'bg-[#f0f0f0]', width: 200,
                    cellRenderer: (data: any) => {
                        return (
                            <p className='hover:text-primary font-semibold cursor-pointer'>{data.value ? moment(data.value).format(DATE_FORMAT) : '-'}</p>
                        )
                    }
                },
                {
                    headerName: "Actions",
                    field: "actions",
                    headerClass: 'bg-[#f0f0f0] text-center',
                    width: 90,

                    cellRenderer: (params: any) => {
                        return (
                            <div className='relative h-full w-full flex items-center justify-center'>
                                <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    const dropdown: any = document.querySelector('.action-dropdown');
                                    if (dropdown) {
                                        dropdown.focus();
                                    }
                                    return false;
                                }} />
                                <select
                                    onChange={(e) => {

                                        handleActionChange(e, params);
                                        //e.target.value = '';
                                    }}
                                    onFocus={(e) => {
                                        e.target.selectedIndex = -1;
                                    }
                                    }
                                    className="action-dropdown"
                                    value={''}
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        opacity: 0,
                                        cursor: "pointer",
                                    }}
                                >
                                    <option value="edit">Edit</option>
                                    <option value="delete">Delete</option>
                                    <option value="duplicate">Duplicate</option>
                                    <option value="move-asset">Move Asset</option>
                                    <option value="qr">Print QR Code</option>
                                    <option value="schedule-maintenance">Schedule Maintenance</option>
                                </select>
                            </div>
                        );
                    },

                }
            ]);
        }
        console.log("statuslist", statuslist);
    }, [statuslist]);

    useEffect(() => {
        if (rowData) {
            getAssetsList();
        }
    }, [currentPage, searchParam, filters]);

    // console.log("statuslist", statuslist);
    const createAssetRef:any = useRef();
    return (
        <Layout>
            <Header title='Assets'>
                <Header.Right>
                    <Drawer _ref={addNewAssetRef} onClose={() => {
                        setEditData(null);
                        createAssetRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button>{editData ? 'Edit' : 'Add New'} Assets</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Assets' : 'Create New Assets'} className='!w-[39.563rem]'>
                            <CreateAssets _ref={createAssetRef} editData={editData} onCreate={() => {
                                setEditData(null);
                                getAssetsList();
                                addNewAssetRef?.current?.close();
                            }} onCancel={() => {
                                setEditData(null);
                                addNewAssetRef?.current?.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>

                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility'>
                            <Menu onClick={onBulkExport}>Move Assets</Menu>
                            <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu onClick={onBulkExportPdf}>Export pdf</Menu>
                            <Menu onClick={onBulkPrintQR}>Print QR Code</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} />
            </div>
            <div className='bg-[#FAFAFA]'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} /></Button>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='light'><Icon name='grlocation' size={1.20} /> Location <Icon name='arrowdown' size={1.10} /></Button>
                        </Dropdown.Button>
                        <Dropdown.Content >
                            {facilityoption?.map((facility: any) => {
                                return (
                                    <Menu onClick={() => {
                                        console.log('facility', facility);
                                        setFilters({ ...filters, facilityIDs: [facility.value] })
                                    }}>{facility.label}</Menu>
                                )
                            }
                            )}
                        </Dropdown.Content>
                    </Dropdown>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => { setFilters({}) }} >Clear Filters</p>
                </div>
                <div className="ag-theme-alpine mx-4  h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs} // Pass columnDefs
                        rowData={rowData} // Pass rowData
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                    />
                </div>
            </div>


            <StatusChangeReasonModal
                _ref={statusChangeReasonModalRef}
                onUpdate={getAssetsList}
                onCancel={getAssetsList}
                data={statusChangeData}
            />
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default Assets;